(function installMonogramStockGuard(win, doc) {
  const config2 = win.EtoileMonogramStockConfig;
  if (!config2 || win.Shopify?.shop !== config2.shop || win.EtoileMelbourneStockGuard) return;
  win.EtoileMelbourneStockGuard = true;
  const originalFetch = win.fetch.bind(win);
  const root = win.Shopify?.routes?.root || "/";
  let lastKey = "";
  let lastCheck = 0;
  let version3 = 0;
  let pending = Promise.resolve();
  let banner;
  const personalized = (item) => Object.entries(item?.properties || {}).some(([key, value]) => key.toLowerCase() === "personalisation" && String(value).trim().toLowerCase() === "monogram" || key.toLowerCase() === "letters" && String(value).trim().length > 0);
  const idOf = (item) => String(item?.variant_id ?? item?.id ?? "").replace(/^gid:\/\/shopify\/ProductVariant\//, "");
  function selection() {
    const primary = doc.querySelector(".product__form");
    const monoId = doc.querySelector('.product-monogram input[name="id"]')?.value;
    const formId = primary?.querySelector('[name="id"]')?.value;
    const urlId = new URL(win.location.href).searchParams.get("variant");
    const id = String(formId || monoId || urlId || "");
    if (urlId && id && urlId !== id) return { id: "", quantity: 1 };
    const quantity = Number(primary?.querySelector('[name="quantity"]')?.value ?? 1);
    return { id, quantity };
  }
  async function check2(id, quantity) {
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return false;
    const url2 = new URL(config2.endpoint);
    url2.search = new URLSearchParams({ shop: config2.shop, variantId: id, quantity: String(quantity) }).toString();
    const controller = new win.AbortController();
    const timeout = win.setTimeout(() => controller.abort(), 7e3);
    try {
      const response = await originalFetch(url2.href, { credentials: "omit", cache: "no-store", signal: controller.signal });
      if (!response.ok) return false;
      const result = await response.json();
      return result.eligible === true && result.reason === "available";
    } catch {
      return false;
    } finally {
      win.clearTimeout(timeout);
    }
  }
  function setState(state) {
    if (doc.documentElement.getAttribute("data-etoile-melbourne-stock") !== state)
      doc.documentElement.setAttribute("data-etoile-melbourne-stock", state);
  }
  async function refresh(force = false) {
    const selected = selection();
    const key = `${selected.id}:${selected.quantity}`;
    if (!force && key === lastKey && Date.now() - lastCheck < 2e4) return;
    lastKey = key;
    lastCheck = Date.now();
    const current = ++version3;
    setState("checking");
    const allowed = await check2(selected.id, selected.quantity);
    if (current !== version3) return;
    const now = selection();
    if (`${now.id}:${now.quantity}` !== key) {
      void refresh(true);
      return;
    }
    setState(allowed ? "eligible" : "unavailable");
  }
  function report() {
    if (!banner) {
      banner = doc.createElement("div");
      banner.setAttribute("role", "alert");
      banner.className = "etoile-monogram-stock-error";
      (doc.querySelector(".product-monogram") || doc.body).appendChild(banner);
    }
    banner.textContent = "Monogramming is unavailable for this colour or quantity at Melbourne Warehouse. No items were added. Please choose another colour or try again.";
    setState("unavailable");
    return new win.Response(
      JSON.stringify({ status: 422, message: "Monogram stock unavailable", description: banner.textContent }),
      { status: 422, headers: { "content-type": "application/json" } }
    );
  }
  function decodeFields(body) {
    const single = { properties: {} };
    const items = [];
    for (const [key, value] of body.entries()) {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$|^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/);
      if (match) {
        const index2 = Number(match[1] ?? match[3]);
        if (index2 > 100) throw new Error("Invalid cart payload");
        const item = items[index2] ||= { properties: {} };
        if (match[2]) item[match[2]] = value;
        else item.properties[match[4]] = value;
      } else if (key === "id" || key === "quantity") single[key] = value;
      else if (/^properties\[[^\]]+\]$/.test(key)) single.properties[key.slice(11, -1)] = value;
    }
    return items.length ? { items } : single;
  }
  async function payload(input, options) {
    let body = options?.body;
    if (body === void 0 && typeof input?.clone === "function") {
      const request = input.clone();
      const type = request.headers.get("content-type") || "";
      if (type.includes("multipart/form-data")) return decodeFields(await request.formData());
      body = await request.text();
    }
    if (typeof body?.entries === "function") return decodeFields(body);
    if (typeof body === "string") {
      try {
        return JSON.parse(body);
      } catch {
        return decodeFields(new URLSearchParams(body));
      }
    }
    throw new Error("Unverified cart payload");
  }
  async function add(input, options) {
    let data;
    try {
      data = await payload(input, options);
    } catch {
      return report();
    }
    const lines = Array.isArray(data.items) ? data.items : [data];
    const additions = lines.filter(personalized);
    if (!additions.length) return originalFetch(input, options);
    try {
      const response = await originalFetch(`${root}cart.js`, { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) return report();
      const cart = await response.json();
      if (!Array.isArray(cart.items)) return report();
      const totals = /* @__PURE__ */ new Map();
      for (const item of additions) {
        const id = idOf(item);
        const quantity = Number(item.quantity ?? 1);
        if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return report();
        totals.set(id, (totals.get(id) || 0) + quantity);
      }
      for (const item of cart.items.filter(personalized)) {
        const id = idOf(item);
        if (totals.has(id)) {
          const quantity = Number(item.quantity);
          if (!Number.isSafeInteger(quantity) || quantity < 1) return report();
          totals.set(id, totals.get(id) + quantity);
        }
      }
      for (const [id, quantity] of totals) if (!await check2(id, quantity)) return report();
      if (banner) banner.textContent = "";
      return originalFetch(input, options);
    } catch {
      return report();
    }
  }
  win.fetch = (input, options) => {
    const path = new URL(typeof input === "string" ? input : input.url ?? input.href, win.location.href).pathname;
    const method = String(options?.method || input?.method || "GET").toUpperCase();
    if (!/\/cart\/add(?:\.js)?$/.test(path) || method !== "POST") return originalFetch(input, options);
    const operation = pending.then(() => add(input, options));
    pending = operation.then(() => void 0, () => void 0);
    return operation;
  };
  setState("checking");
  doc.addEventListener("change", () => void refresh(true), true);
  doc.addEventListener("DOMContentLoaded", () => void refresh(true));
  doc.addEventListener("visibilitychange", () => {
    if (!doc.hidden) void refresh(true);
  });
  win.setInterval(() => {
    if (!doc.hidden) void refresh();
  }, 500);
  void refresh();
})(window, document);